exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{height:100vh}body{margin:0;background:linear-gradient(rgba(20,30,48,.45),rgba(20,30,48,.45)),url(" + require("../assets/img/sky.jpg") + ");background-size:cover}.wrap-banner{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:100%;position:absolute;color:#fff}h2{font-size:7rem;font-family:Teko,sans-serif;text-shadow:8px 8px #000;text-transform:uppercase;margin:0}.btn-si{background:#dd4b39 url(" + require("../assets/img/sign-in.svg") + ") no-repeat 1em;background-size:2em;border-radius:.5em;border:none;color:#fff;fill:#fff;cursor:pointer;font-size:1em;height:4em;line-height:1em;padding:0 2em 0 4em;text-decoration:none;transition:all .5s}.btn-si:hover{background-color:#e47365}.btn-si:active{background-color:#c23321}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d4225cc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 131
// module chunks = 0